import { render, staticRenderFns } from "./StartRepair.vue?vue&type=template&id=39021776&scoped=true"
import script from "./StartRepair.vue?vue&type=script&lang=js"
export * from "./StartRepair.vue?vue&type=script&lang=js"
import style0 from "./StartRepair.vue?vue&type=style&index=0&id=39021776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39021776",
  null
  
)

export default component.exports